import * as React from "react";
import { read, utils } from "xlsx";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Grid, Typography } from "@mui/material";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import notifyContext from "../../../Context/notifyContext";
import { saveMany } from "../../../../services/Salarie__Service";

const ImportBalance = (props) => {
  const { client, open, onClose } = props;
  const notify = React.useContext(notifyContext);

  const [loading, setLoading] = React.useState(false);
  const [loadingData, setLoadingData] = React.useState(false);
  const [error, setError] = React.useState("");
  const [data, setData] = React.useState([]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "1px solid black",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      // backgroundColor: "primary",
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleSubmit = () => {
    setLoading(true);
    setError("");

    const details = [];

    data?.forEach((element) => {
      let pays = null;

      switch (element.Pays?.toLocaleLowerCase()) {
        case "cameroun":
          pays = 1;
          break;
        case "gabon":
          pays = 2;
          break;
        case "congo":
          pays = 3;
          break;
        case "tchad":
          pays = 4;
          break;
        default:
          pays = "";
      }
      details.push({
        matricule: element.Matricule,
        nom: element.Noms,
        prenom: element.Prenoms,
        sexe: element.Sexe
          ? element.Sexe.toLocaleLowerCase().substring(0, 1) === "m"
            ? 1
            : 2
          : null,
        date_naissance: element["Date Naissance"]
          ? new Date(element["Date Naissance"]).toLocaleDateString("en-ZA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          : null,
        fonction: element.Fonction,
        ancinenete: element["ancinenete"]
          ? new Date(element["ancinenete"]).toLocaleDateString("en-ZA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          : null,
        email1: element["Email 1"],
        email2: element["Email 2"],
        tel1: element["Tel 1"] ? element["Tel 1"] : null,
        tel2: element["Tel 2"],
        pays: pays,
        ville: element.Ville,
        adresse: element.Adresse,
      });
    });

    saveMany(client.id, details)
      .then(() => {
        notify("importé avec succès", "success");
        onClose();
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          setError(error.response.data.message);
          notify(error.response.data.message, "error");
        } else {
          setError("Problème au niveau du serveur");
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const handleImport = React.useCallback(
    (e) => {
      const files = e.target.files;

      if (files && files.length > 0) {
        setLoadingData(true);
        const file = files[0];

        const reader = new FileReader();

        reader.onload = (event) => {
          const wb = read(event?.target?.result);
          const sheets = wb.SheetNames;

          if (sheets.length) {
            const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], {
              dateNF: "iso",
              // header: 1,
              defval: "",
              blankrows: false,
              raw: false,
            });

            setData(() => [...(rows || []).filter((row) => !!row.Matricule)]);
            setLoadingData(false);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },
    [setLoadingData, setData]
  );

  return (
    <div>
      <Dialog fullScreen open={open} onClose={() => {}}>
        <form
          style={{
            minWidth: "500px",
          }}
        >
          <DialogTitle textAlign={"center"}>
            {"Importer les salaries"}{" "}
          </DialogTitle>
          <DialogContent>
            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            {data && data.length > 0 ? (
              <Box>
                <Grid
                  justifyContent={"space-between"}
                  alignItems="center"
                  gap={4}
                  display="flex"
                  mb={2}
                >
                  <Button variant="contained" component="label">
                    Telecharger
                    <input
                      hidden
                      // accept="*"
                      type="file"
                      onChange={handleImport}
                    />
                  </Button>
                </Grid>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="import salaries table"
                  >
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>#</StyledTableCell>
                        <StyledTableCell>Matricule</StyledTableCell>
                        <StyledTableCell>Noms</StyledTableCell>
                        <StyledTableCell>Prenoms</StyledTableCell>
                        <StyledTableCell>Sexe</StyledTableCell>
                        <StyledTableCell>Date Naissance</StyledTableCell>
                        <StyledTableCell>Fonction</StyledTableCell>
                        <StyledTableCell>Anciennete</StyledTableCell>
                        <StyledTableCell>Email 1</StyledTableCell>
                        <StyledTableCell>Email 2</StyledTableCell>
                        <StyledTableCell>Tel 1</StyledTableCell>
                        <StyledTableCell>Tel 2</StyledTableCell>
                        <StyledTableCell>Pays</StyledTableCell>
                        <StyledTableCell>Ville</StyledTableCell>
                        <StyledTableCell>Adresse</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {(data || [])
                        ?.filter((row) => !!row.Matricule)
                        .map((row, index) => {
                          return (
                            <StyledTableRow
                              key={row.noms + index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                {index + 1}
                              </TableCell>
                              <TableCell>{row.Matricule}</TableCell>
                              <TableCell>{row.Noms}</TableCell>
                              <TableCell>{row.Prenoms}</TableCell>
                              <TableCell>{row.Sexe}</TableCell>
                              <TableCell>
                                {row["Date Naissance"]
                                  ? new Date(
                                      row["Date Naissance"]
                                    ).toLocaleDateString()
                                  : ""}
                              </TableCell>
                              <TableCell>{row.Fonction}</TableCell>
                              <TableCell>
                                {row.Anciennete
                                  ? new Date(
                                      row.Anciennete
                                    ).toLocaleDateString()
                                  : ""}
                              </TableCell>
                              <TableCell>{row["Email 1"]}</TableCell>
                              <TableCell>{row["Email 2"]}</TableCell>
                              <TableCell>{row["Tel 1"]}</TableCell>
                              <TableCell>{row["Tel 2"]}</TableCell>
                              <TableCell>{row.Pays}</TableCell>
                              <TableCell>{row.Ville}</TableCell>
                              <TableCell>{row.Adresse}</TableCell>
                            </StyledTableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : (
              <Box
                height={"100%"}
                width={"100%"}
                border={1}
                borderColor={"darkgrey"}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: "16px",
                  gap: "40px",
                  borderStyle: "dashed",
                }}
              >
                {loadingData ? (
                  <CircularProgress />
                ) : (
                  <>
                    <Typography fontSize={20} fontWeight={700}>
                      Aucun fichier selectionne
                    </Typography>
                    <Button variant="contained" component="label">
                      Télécharger
                      <input
                        hidden
                        // accept="*"
                        type="file"
                        onChange={handleImport}
                      />
                    </Button>
                  </>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions
            sx={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button onClick={onClose} variant="outlined">
              Annuler
            </Button>
            <Button
              variant="contained"
              type={loading ? "button" : "submit"}
              disabled={loading || data.length <= 0}
              endIcon={loading ? <CircularProgress /> : <></>}
              onClick={() => {
                handleSubmit();
              }}
            >
              {"Importer"}{" "}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default React.memo(ImportBalance);
